import { render, staticRenderFns } from "./criterios.vue?vue&type=template&id=50b4c073&scoped=true&"
import script from "./criterios.vue?vue&type=script&lang=js&"
export * from "./criterios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4c073",
  null
  
)

export default component.exports